<template>
	<div class="table-wrap" v-if="tableData?.length">
		<table class="table table--default">
			<thead class="table__head">
			<tr class="table__row">
				<td class="table__col">№</td>
				<td class="table__col">Тип закупки</td>
				<td class="table__col">Наименование тендера</td>
				<td class="table__col">Товаров в&nbsp;тендере</td>
				<td class="table__col">Место доставки</td>
				<td class="table__col">Начало торгов</td>
				<td class="table__col">Окончание торгов</td>
				<td class="table__col">До завершения</td>
				<td class="table__col">Статус</td>
				<td class="table__col"></td>
			</tr>
			<tr class="table__margin">
				<td colspan="100%"></td>
			</tr>
			</thead>
			<tbody class="table__body">
				<TendersRow v-for="item in tableData" :key="item.id" :item="item"></TendersRow>
			</tbody>
		</table>
	</div>
	<div v-else class="table-card__empty">Тендеры не найдены</div>
</template>

<script>
import TendersRow from "@/components/sections/Tenders/TenderPage/TendersRow.vue";

export default {
	name: "TendersTable",
	components: {TendersRow},
    props: {
        tableData: {
            type: Array,
            default: () => []
        },
    },
}
</script>


